<script lang="ts" setup>
import type { ContentItemTypes } from '~/utils/graphql/graphql'

const props = defineProps<{
  item: ContentItemTypes | null
  class: string
  style?: string | undefined
  lazy?: boolean | undefined
}>()
</script>

<template>
  <PPicture
    v-if="item"
    :item="item"
    :lazy="lazy === undefined || lazy"
    :class="props.class"
    :style="props.style"
  />
</template>
